import React, { useState } from 'react';

import validation from '../utils/validation';

export const usePasswordInput = (
  initialValue: string,
  field: string,
  onChangeHook?: (field: string, value: string) => void,
  onBlurHook?: (field: string, value: string) => void,
  onFocusHook?: (field: string, value: string) => void,
) => {
  const [value, setValue] = useState(initialValue);
  const [isValid, validations] = validation.password.validate(value);

  return {
    value,
    setValue,
    reset: () => setValue(''),
    isValid,
    validations,
    bind: {
      value,
      onChange: (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        setValue(value);
        if (onChangeHook) {
          onChangeHook(field, value);
        }
      },
      ...(onBlurHook ? { onBlur: () => onBlurHook(field, value) } : {}),
      ...(onFocusHook ? { onFocus: () => onFocusHook(field, value) } : {}),
    },
  };
};
